export const COUNTRIES = [
  { code: 'AF', name: 'Afganistan', phone: '+93', format: 'XX XXX XXXX' },
  { code: 'AL', name: 'Arnavutluk', phone: '+355', format: 'XX XXX XXXX' },
  { code: 'DE', name: 'Almanya', phone: '+49', format: 'XXX XXXXXXXX' },
  { code: 'US', name: 'Amerika Birlesik Devletleri', phone: '+1', format: 'XXX XXX XXXX' },
  { code: 'AD', name: 'Andorra', phone: '+376', format: 'XXX XXX' },
  { code: 'AO', name: 'Angola', phone: '+244', format: 'XXX XXX XXX' },
  { code: 'AR', name: 'Arjantin', phone: '+54', format: 'XX XXXX XXXX' },
  { code: 'AU', name: 'Avustralya', phone: '+61', format: 'XXX XXX XXX' },
  { code: 'AT', name: 'Avusturya', phone: '+43', format: 'XXX XXXXXXX' },
  { code: 'AZ', name: 'Azerbaycan', phone: '+994', format: 'XX XXX XX XX' },
  { code: 'BS', name: 'Bahamalar', phone: '+1242', format: 'XXX XXXX' },
  { code: 'BH', name: 'Bahreyn', phone: '+973', format: 'XXXX XXXX' },
  { code: 'BD', name: 'Banglades', phone: '+880', format: 'XXXX XXXXXX' },
  { code: 'BY', name: 'Belarus', phone: '+375', format: 'XX XXX XX XX' },
  { code: 'BE', name: 'Belcika', phone: '+32', format: 'XXX XX XX XX' },
  { code: 'BZ', name: 'Belize', phone: '+501', format: 'XXX XXXX' },
  { code: 'BA', name: 'Bosna Hersek', phone: '+387', format: 'XX XXX XXX' },
  { code: 'BR', name: 'Brezilya', phone: '+55', format: 'XX XXXXX XXXX' },
  { code: 'BN', name: 'Brunei', phone: '+673', format: 'XXX XXXX' },
  { code: 'BG', name: 'Bulgaristan', phone: '+359', format: 'XX XXX XXXX' },
  { code: 'CL', name: 'Sili', phone: '+56', format: 'X XXXX XXXX' },
  { code: 'CN', name: 'Cin', phone: '+86', format: 'XXX XXXX XXXX' },
  { code: 'CO', name: 'Kolombiya', phone: '+57', format: 'XXX XXX XXXX' },
  { code: 'HR', name: 'Hirvatistan', phone: '+385', format: 'XX XXX XXXX' },
  { code: 'CY', name: 'Kibris', phone: '+357', format: 'XX XXXXXX' },
  { code: 'CZ', name: 'Cek Cumhuriyeti', phone: '+420', format: 'XXX XXX XXX' },
  { code: 'DK', name: 'Danimarka', phone: '+45', format: 'XX XX XX XX' },
  { code: 'EC', name: 'Ekvador', phone: '+593', format: 'XX XXX XXXX' },
  { code: 'EG', name: 'Misir', phone: '+20', format: 'XX XXXX XXXX' },
  { code: 'EE', name: 'Estonya', phone: '+372', format: 'XXXX XXXX' },
  { code: 'ET', name: 'Etiyopya', phone: '+251', format: 'XX XXX XXXX' },
  { code: 'FI', name: 'Finlandiya', phone: '+358', format: 'XX XXX XXXX' },
  { code: 'FR', name: 'Fransa', phone: '+33', format: 'X XX XX XX XX' },
  { code: 'GE', name: 'Gurcistan', phone: '+995', format: 'XXX XX XX XX' },
  { code: 'GH', name: 'Gana', phone: '+233', format: 'XX XXX XXXX' },
  { code: 'GR', name: 'Yunanistan', phone: '+30', format: 'XXX XXX XXXX' },
  { code: 'HU', name: 'Macaristan', phone: '+36', format: 'XX XXX XXXX' },
  { code: 'IS', name: 'Izlanda', phone: '+354', format: 'XXX XXXX' },
  { code: 'IN', name: 'Hindistan', phone: '+91', format: 'XXXXX XXXXX' },
  { code: 'ID', name: 'Endonezya', phone: '+62', format: 'XXX XXXX XXXX' },
  { code: 'IR', name: 'Iran', phone: '+98', format: 'XXX XXX XXXX' },
  { code: 'IQ', name: 'Irak', phone: '+964', format: 'XXX XXX XXXX' },
  { code: 'IE', name: 'Irlanda', phone: '+353', format: 'XX XXX XXXX' },
  { code: 'IL', name: 'Israil', phone: '+972', format: 'XX XXX XXXX' },
  { code: 'IT', name: 'Italya', phone: '+39', format: 'XXX XXX XXXX' },
  { code: 'JP', name: 'Japonya', phone: '+81', format: 'XX XXXX XXXX' },
  { code: 'JO', name: 'Urdun', phone: '+962', format: 'X XXXX XXXX' },
  { code: 'KZ', name: 'Kazakistan', phone: '+7', format: 'XXX XXX XX XX' },
  { code: 'KE', name: 'Kenya', phone: '+254', format: 'XXX XXXXXX' },
  { code: 'KKTC', name: 'KKTC', phone: '+90', format: '5XX XXX XX XX' },
  { code: 'KW', name: 'Kuveyt', phone: '+965', format: 'XXXX XXXX' },
  { code: 'KG', name: 'Kirgizistan', phone: '+996', format: 'XXX XXX XXX' },
  { code: 'LV', name: 'Letonya', phone: '+371', format: 'XXXX XXXX' },
  { code: 'LB', name: 'Lubnan', phone: '+961', format: 'XX XXX XXX' },
  { code: 'LY', name: 'Libya', phone: '+218', format: 'XX XXX XXXX' },
  { code: 'LT', name: 'Litvanya', phone: '+370', format: 'XXX XXXXX' },
  { code: 'LU', name: 'Luksemburg', phone: '+352', format: 'XXX XXX XXX' },
  { code: 'MK', name: 'Kuzey Makedonya', phone: '+389', format: 'XX XXX XXX' },
  { code: 'MY', name: 'Malezya', phone: '+60', format: 'XX XXXX XXXX' },
  { code: 'MT', name: 'Malta', phone: '+356', format: 'XXXX XXXX' },
  { code: 'MX', name: 'Meksika', phone: '+52', format: 'XX XXXX XXXX' },
  { code: 'MD', name: 'Moldova', phone: '+373', format: 'XXXX XXXX' },
  { code: 'ME', name: 'Karadag', phone: '+382', format: 'XX XXX XXX' },
  { code: 'MA', name: 'Fas', phone: '+212', format: 'XXXX XXXXXX' },
  { code: 'NL', name: 'Hollanda', phone: '+31', format: 'XX XXX XXXX' },
  { code: 'NZ', name: 'Yeni Zelanda', phone: '+64', format: 'XX XXX XXXX' },
  { code: 'NG', name: 'Nijerya', phone: '+234', format: 'XXX XXX XXXX' },
  { code: 'NO', name: 'Norvec', phone: '+47', format: 'XXX XX XXX' },
  { code: 'OM', name: 'Umman', phone: '+968', format: 'XXXX XXXX' },
  { code: 'PK', name: 'Pakistan', phone: '+92', format: 'XXX XXXXXXX' },
  { code: 'PA', name: 'Panama', phone: '+507', format: 'XXXX XXXX' },
  { code: 'PY', name: 'Paraguay', phone: '+595', format: 'XXX XXXXXX' },
  { code: 'PE', name: 'Peru', phone: '+51', format: 'XXX XXX XXX' },
  { code: 'PH', name: 'Filipinler', phone: '+63', format: 'XXX XXX XXXX' },
  { code: 'PL', name: 'Polonya', phone: '+48', format: 'XXX XXX XXX' },
  { code: 'PT', name: 'Portekiz', phone: '+351', format: 'XXX XXX XXX' },
  { code: 'QA', name: 'Katar', phone: '+974', format: 'XXXX XXXX' },
  { code: 'RO', name: 'Romanya', phone: '+40', format: 'XXX XXX XXX' },
  { code: 'RU', name: 'Rusya', phone: '+7', format: 'XXX XXX XX XX' },
  { code: 'SA', name: 'Suudi Arabistan', phone: '+966', format: 'XX XXX XXXX' },
  { code: 'RS', name: 'Sirbistan', phone: '+381', format: 'XX XXX XXXX' },
  { code: 'SG', name: 'Singapur', phone: '+65', format: 'XXXX XXXX' },
  { code: 'SK', name: 'Slovakya', phone: '+421', format: 'XXX XXX XXX' },
  { code: 'SI', name: 'Slovenya', phone: '+386', format: 'XX XXX XXX' },
  { code: 'ZA', name: 'Guney Afrika', phone: '+27', format: 'XX XXX XXXX' },
  { code: 'KR', name: 'Guney Kore', phone: '+82', format: 'XX XXXX XXXX' },
  { code: 'ES', name: 'Ispanya', phone: '+34', format: 'XXX XXX XXX' },
  { code: 'LK', name: 'Sri Lanka', phone: '+94', format: 'XX XXX XXXX' },
  { code: 'SE', name: 'Isvec', phone: '+46', format: 'XX XXX XXXX' },
  { code: 'CH', name: 'Isvicre', phone: '+41', format: 'XX XXX XX XX' },
  { code: 'SY', name: 'Suriye', phone: '+963', format: 'XXX XXX XXX' },
  { code: 'TW', name: 'Tayvan', phone: '+886', format: 'XXX XXX XXX' },
  { code: 'TH', name: 'Tayland', phone: '+66', format: 'XX XXX XXXX' },
  { code: 'TN', name: 'Tunus', phone: '+216', format: 'XX XXX XXX' },
  { code: 'TR', name: 'Turkiye', phone: '+90', format: '5XX XXX XX XX' },
  { code: 'TM', name: 'Turkmenistan', phone: '+993', format: 'XX XXXXXX' },
  { code: 'UA', name: 'Ukrayna', phone: '+380', format: 'XX XXX XX XX' },
  { code: 'AE', name: 'Birlesik Arap Emirlikleri', phone: '+971', format: 'XX XXX XXXX' },
  { code: 'GB', name: 'Birlesik Krallik', phone: '+44', format: 'XXXX XXXXXX' },
  { code: 'UY', name: 'Uruguay', phone: '+598', format: 'XX XXX XXX' },
  { code: 'UZ', name: 'Ozbekistan', phone: '+998', format: 'XX XXX XX XX' },
  { code: 'VE', name: 'Venezuela', phone: '+58', format: 'XXX XXX XXXX' },
  { code: 'VN', name: 'Vietnam', phone: '+84', format: 'XXX XXX XXXX' },
];

// Sorted alphabetically by Turkish name, Turkiye and KKTC pinned to top
export const COUNTRIES_SORTED = [
  COUNTRIES.find(c => c.code === 'TR'),
  COUNTRIES.find(c => c.code === 'KKTC'),
  ...COUNTRIES.filter(c => c.code !== 'TR' && c.code !== 'KKTC').sort((a, b) => a.name.localeCompare(b.name, 'tr'))
];

export const getCountryByCode = (code) => COUNTRIES.find(c => c.code === code);
export const getPhoneFormat = (countryCode) => getCountryByCode(countryCode)?.format || 'XXX XXX XXXX';
export const getPhonePrefix = (countryCode) => getCountryByCode(countryCode)?.phone || '+90';
